<template>
  <div>
    <portal to="global-modal-portal" v-if="isPdfViewerActive" :order="portalOrder" :disabled="!usePortal">
        <b-modal custom-class="pdf-modal" :active.sync="isPdfViewerActive" scroll="keep" :has-modal-card="true" v-if="isPdfViewerActive"  :canCancel="false" :full-screen="isFullScreenRequired" style="z-index: 9002;">
          <div class="modal-card">
              <header class="modal-card-head">
                <p class="modal-card-title">{{localPdfDocument ? localPdfDocument.name : "Loading requested pdf ...."}}</p>
                <span class="title is-7 is-pulled-right" v-if="isPreviewDownloading">
                  Loading your pdf ....
                </span>
              </header>
              <section class="modal-card-body" :class="{'pdf-modal-body-full-screen': isFullScreenRequired}" v-if="localPdfDocument != null">
                <pdf :rotate="rotateDegrees" ref="pdfViewer" :src="localPdfDocument.src"></pdf>
                <b-loading :is-full-page="false" :active="isPreviewDownloading" :canCancel="false" v-if="isPreviewDownloading"></b-loading>
              </section>
              <section class="modal-card-body small-bottom-padding small-top-padding" v-else>
              </section>            
              <footer class="modal-card-foot">
                <button class="button" @click.prevent="closePdf">Close</button>
                <button class="button" @click.prevent="onDownloadFile">Download</button>
                <button class="button" @click.prevent="onPrint">Print</button>
                <button class="button" @click.prevent="onRotate" style="margin-left:auto;" v-if="enableRotate">Rotate</button>
                <button class="button is-info is-pulled-right" @click="onShowSendModal" type="button" v-if="hasFileLocation">Send</button>
                <slot name="extra-footer-actions" v-if="pdfFile"></slot>
              </footer>
          </div>
        </b-modal>
    </portal>
    
    <portal to="global-modal-portal" v-if="isSendPdfModalActive" :order="pdfSendModalOrder" :disabled="!usePortal">
      <b-modal :width="960" :active.sync="isSendPdfModalActive" scroll="keep" :has-modal-card="true" class="document-send-modal">
        <div class="modal-card" style="width: 960px !important;">
          <form @submit.prevent="onValidate" data-vv-scope="recipient-form">
            <header class="modal-card-head">
              <p class="modal-card-title">Send document</p>
            </header>
              <section class="modal-card-body view-container" style="padding:12px">
                <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage"></error-display-component>                
                <b-tabs v-model="tabIndex" size="is-small" :animated="false" type="is-toggle">                  
                  <b-tab-item label="History" icon-pack="fas"  icon="fas fa-history fa-sm">
                    <div class="columns is-multiline is-mobile">                      
                      <div class="column is-12" v-if="hasDocumentSentEvents">
                        <b-table
                          :data="documentSentData"
                          :sortable="false">
                          <template slot-scope="props">
                            <b-table-column field="recipientName" label="Recipient Name" v-tooltip="props.row.recipientName">
                              {{ props.row.recipientName }}
                            </b-table-column>
                            <b-table-column field="email" label="Email" v-tooltip="props.row.toEmailAddress">
                              {{ props.row.toEmailAddresses }}
                            </b-table-column>
                            <b-table-column field="mobile" label="Mobile" v-tooltip="props.row.toMobileNumbers">
                              {{ props.row.toMobileNumbers }}
                            </b-table-column>
                            <b-table-column field="createdAt" label="Created">
                              {{ props.row.createdAt | formatDateOnly }}
                            </b-table-column>
                          </template>
                          <template slot="empty">
                            <section class="section">
                              <div class="has-text-centered">
                                <p><b-icon icon="emoticon-sad" size="is-large"></b-icon></p>
                                <p>Document not sent to any previous recipients.</p>
                              </div>
                            </section>
                          </template>
                        </b-table>
                    </div>
                    </div>
                  </b-tab-item>
                  <b-tab-item label="Send" icon-pack="fas"  icon="fas fa-info-circle fa-sm">
                    <div class="columns is-multiline is-mobile">
                      <div class="column is-12">
                        <button-list-selector
                          validateAs="recipient type"
                          scope="recipient-form"
                          label="Recipient Type"
                          :required="true"
                          v-model="selectedRecipientType"
                          :allowDeselection="false"
                          v-on:on-change="onRecipientTypeChange"
                          :availableValues="filteredCostPayeeTypes">
                        </button-list-selector>
                      </div>
                      <div id="entity-selector" class="column is-12">
                        <supplier-selector-convert
                          v-if="isSupplierRecipient"
                          class="is-fullwidth"
                          label="Wholesaler/Dealer"
                          validateAs="wholesaler/dealer"
                          placeholder="Type to search for a loaded wholesaler/dealer"
                          v-model="selectedRecipientSupplier"
                          :required="true"
                          :useValidator="thisValidator"
                          data-vv-scope="recipient-form"
                          :isDisabled="false"
                          :allowEdit="true">
                        </supplier-selector-convert>

                        <customer-selector-convert
                          v-if="isCustomerRecipient"
                          label="Customer"
                          validateAs="customer"
                          class="is-fullwidth"
                          v-model="selectedRecipientCustomer"
                          :selectedDealer="selectedDealer"
                          :required="true"
                          :showNewAction="false"
                          :useValidator="thisValidator"
                          data-vv-scope="recipient-form"
                          :isDisabled="false"
                          :allowEdit="true">
                        </customer-selector-convert>
                      </div>
                      <div class="column is-12" v-if="recipientSelected">
                        <div class="field">
                          <label class="label">Recipients<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                          <multiselect
                            :multiple="true"
                            :taggable="true"
                            v-validate="{'required': true}"
                            data-vv-scope="recipient-form"
                            data-vv-as="recipient"
                            data-vv-validate-on="input|close"
                            :class="{'is-danger': errors.has('recipient-form.recipients') }"
                            @tag="onRecipientAdded"
                            name="recipients"
                            label="fullName"
                            trackBy="email"
                            tagPlaceholder="Enter to add email address"
                            v-model="selectedRecipients"
                            :options="selectedRecipients"
                            :disabled="false">
                          </multiselect>
                          <span v-show="errors.has('recipient-form.recipients')" class="help is-danger"><i v-show="errors.has('recipient-form.recipients')" class="fas fa-exclamation-triangle"></i> {{ errors.first('recipient-form.recipients') }}</span>
                        </div>
                      </div>
                      <div class="column is-12" v-if="recipientSelected">
                        <div class="field">
                          <label class="label">Subject</label>
                          <div class="control">
                            <input name="overridingSubject" data-vv-as="overridingSubject" :class="{'input': true }" type="text" v-model="overridingSubject">
                          </div>
                        </div>
                      </div>
                      <div class="column is-12" v-if="recipientSelected">
                        <div class="field">
                          <label class="label">Message (optional)</label>
                          <div class="control">
                            <textarea rows="10" name="optionalMessage" :class="{'textarea': true}" data-vv-as="optional message" v-model="optionalMessage"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab-item>
                </b-tabs>

              </section>
              <footer class="modal-card-foot">
                <div class="is-fullwidth">
                  <button v-if="tabIndex === 0" class="button is-warning" :class="{'is-loading': isLoading}" @click="next()" type="button">Next</button>
                  <button v-if="tabIndex === 1" class="button is-warning" :class="{'is-loading': isLoading}" @click="previous()" type="button">Previous</button>
                  <button v-if="tabIndex === 1" class="button is-primary" :class="{'is-loading': isSaving }" type="button" :disabled="!formDataValid" @click="validateBeforeSubmit">Send</button>
                  <button class="button is-danger is-pulled-right" @click="onCancel" type="button">Cancel</button>
                </div>
              </footer>
            </form>
          </div>
      </b-modal>
    </portal>
  </div>
</template>

<script>
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import utilitiesMixin from '@/mixins/generic/utilities'
import { createNamespacedHelpers } from 'vuex'
import documentService from '@/services/documentService'
import ButtonListSelector from '@/components/generic/ButtonListSelector'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'

const mapConfigGetters = createNamespacedHelpers('config').mapGetters
const mapUserGetters = createNamespacedHelpers('user').mapGetters
const mapDealerState = createNamespacedHelpers('dealer').mapState

export default {
  name: 'PdfModalDisplayComponent',
  components: {
    'error-display-component': ErrorDisplayComponent,
    'customer-selector-convert': () => import('@/components/generic/CustomerSelector'),
    'supplier-selector-convert': () => import('@/components/generic/SupplierSelector'),
    'button-list-selector': ButtonListSelector
  },
  mixins: [utilitiesMixin, validateBeforeSubmitMixin],
  props: {
    pdfFile: {
      type: Object,
      default: null
    },
    usePortal: {
      type: Boolean,
      default: true
    },
    portalOrder: {
      type: Number,
      default: 1
    },
    fullScreenMode: {
      type: Boolean,
      default: false
    },
    enableRotate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localPdfDocument: null,
      isPdfViewerActive: false,
      rotateDegrees: 0,
      isPreviewDownloading: false,
      isSendPdfModalActive: false,
      selectedRecipientType: null,
      selectedRecipientCustomer: null,
      selectedRecipientSupplier: null,
      optionalMessage: '',
      selectedRecipients: [],
      serverErrors: [],
      serverErrorMessage: '',
      isSaving: false,
      selectedDealer: null,
      overridingSubject: '',
      tabIndex: 0,
      isLoading: false,
      documentSentData: []
    }
  },
  computed: {
    ...mapUserGetters(['currentUser']),
    ...mapConfigGetters(['definedTypes']),
    ...mapDealerState(['currentDealer']),
    isMobile: function () {
      return window.innerWidth <= 700
    },
    isFullScreenRequired: function () {
      return this.isMobile || this.fullScreenMode
    },
    pdfSendModalOrder: function () {
      let result = this.portalOrder + 1
      return result
    },
    filteredCostPayeeTypes: function () {
      let excludedTypes = [2, 4]
      let filteredTypes = this.definedTypes.costPayeeTypes.filter(function (item) {
        return excludedTypes.indexOf(item.id) === -1
      })
      return filteredTypes
    },
    isSupplierRecipient: function () {
      if (this.selectedRecipientType && this.selectedRecipientType.altName === 'Supplier') {
        return true
      }
      return false
    },
    isCustomerRecipient: function () {
      if (this.selectedRecipientType && this.selectedRecipientType.altName === 'Customer') {
        return true
      }
      return false
    },
    recipientSelected: function () {
      if (this.selectedRecipientType) {
        if (this.selectedRecipientType.altName === 'Customer' && this.selectedRecipientCustomer) {
          return true
        }
        if (this.selectedRecipientType.altName === 'Supplier' && this.selectedRecipientSupplier) {
          return true
        }
      }
      return false
    },
    formDataValid: function () {
      if ((this.selectedRecipientCustomer || this.selectedRecipientSupplier) && this.selectedRecipients && this.selectedRecipients.length > 0) {
        return true
      }
      return false
    },
    thisValidator: function () {
      return (this && this.$validator) ? this.$validator : null
    },
    hasFileLocation() {
      if (this.pdfFile && this.pdfFile.fileLocation) {
        return true
      }
      return false
    },
    hasDocumentSentEvents: function () {
     if (this.documentSentData && this.documentSentData.length > 0) {
       return true
     }
    return false
    }
  },
  methods: {
    closePdf () {
      this.isPdfViewerActive = false
      this.$emit('on-pdf-closed')
    },
    onDownloadFile: function () {
      // A document only the signed-in user may read names its own download: the LiveApi proxy carries no login.
      window.location = this.pdfFile.downloadUrl || (process.env.VUE_APP_ROOT_API + 'document/download?url=' + encodeURI(this.pdfFile.src) + '&fileName=' + encodeURI(this.pdfFile.fileName))
    },
    onPrint: function () {
      var pdfControls = this.$refs.pdfViewer
      if (pdfControls) {
        if (Array.isArray(pdfControls) && pdfControls.length > 0) {
          pdfControls[0].print(100)
        } else {
          pdfControls.print(100)
        }
      } else {
        this.failedToast('Printing support is not available in this browser.')
      }
    },
    loadPdf: function () {
      this.isPreviewDownloading = true
      var srcDocument = {
        name: this.pdfFile.name,
        src: this.pdfFile.src
      }
      this.localPdfDocument = srcDocument
    },
    onPdfLoaded: function () {
      this.isPreviewDownloading = false
      this.$emit('on-pdf-downloaded')
    },
    onRotate: function () {
      let val = this.rotateDegrees + 90
      if (val === 450) val = 0
      this.rotateDegrees = val
      var pdfControls = this.$refs.pdfViewer
      if (pdfControls) {
        if (Array.isArray(pdfControls) && pdfControls.length > 0) {
          pdfControls[0].rotate()
        } else {
          pdfControls.rotate()
        }
      } else {
        this.failedToast('Printing support is not available in this browser.')
      }
    },
    onRecipientTypeChange: function (newPayeeType) {
      this.selectedRecipientCustomer = null
      this.selectedRecipientSupplier = null
    },
    onValidate: function () {
      this.validateBeforeSubmitScoped('recipient-form')
    },
    onCancel: function () {
      this.isPdfViewerActive = true
      this.isSendPdfModalActive = false      
      this.tabIndex = 0
      this.selectedRecipientType = null
      this.selectedRecipientCustomer = null
      this.selectedRecipientSupplier = null
      this.clearAllRecipients()

    },
    clearAllRecipients: function () {
      this.optionalMessage = ''
      this.overridingSubject = ''
      this.selectedRecipients = []
      this.selectedRecipientsMobile = []
      this.mobileInvalidFormat = ''
    },
    onShowSendModal: function () {
      this.isSendPdfModalActive = true
      this.documentSentHistoryCheck()
      this.isPdfViewerActive = false
    },
    onSave: function () {
      var emailAddresses = this.selectedRecipients.map(e => e.email).join(', ')
      var mobileNumbers = this.selectedRecipientsMobile.map(e => e.mobile).join(',')
      
      var fileName = this.pdfFile && this.pdfFile.name ? this.pdfFile.name : ''
      var fileLocation = this.pdfFile && this.pdfFile.fileLocation ? this.pdfFile.fileLocation : ''
      let that = this
      that.isSaving = true
      let sendDocumentRequest = {
        customerId: this.selectedRecipientCustomer != null ? this.selectedRecipientCustomer.id : null,
        supplierId: this.selectedRecipientSupplier != null ? this.selectedRecipientSupplier.id : null,
        fileName: fileName,
        fileLocation: fileLocation,
        toEmailAddress: emailAddresses,
        subject: this.overridingSubject,
        content: this.optionalMessage,
        toMobileNumbers: mobileNumbers,
        userId: this.currentUser.id,
        dealerId: this.currentDealer.id,
        recipientType: this.selectedRecipientType.altName
      }
      documentService.createDocumentRequest(sendDocumentRequest).then(response => {
        that.isSaving = false
        if (response.errors) {
          that.failedToast('Oops! Something went wrong')
          that.serverErrors = response.errors
        } else {
          that.$emit('on-save')
          that.successToast('Success! Request created.')
          that.sendViewMediaControlActive = false
          that.onCancel()
        }
      }).catch((error) => {
        that.failedToast('Oops! Something went wrong')
        that.isSaving = false
        that.serverErrorMessage = error.message
      })
    },
    getMessagePreface: function () {
      let result = ''

      if (this.isCustomerRecipient && this.selectedRecipientCustomer.fullName) {
        result += 'Hi ' + this.selectedRecipientCustomer.fullName + ',\n\n'        
      } else if (this.isSupplierRecipient && this.selectedRecipientSupplier.name) {
        result += 'Hi ' + this.selectedRecipientSupplier.name + ',\n\n'         
      }
      result += 'Please see the attached document for your review.\n\n'

      return result
    },
    onRecipientAdded: function (data) {
      var recipient = {
        fullName: data,
        email: data
      }

      this.selectedRecipients.push(recipient)
    },
    next: function () {
      this.tabIndex = 1
    },
    previous: function () {
      this.tabIndex = 0
    },
    documentSentHistoryCheck: function () {
      this.isLoading = true
      let that = this
      that.documentSentData = []
      var fileLocation = this.pdfFile && this.pdfFile.fileLocation ? this.pdfFile.fileLocation : ''
      documentService.findAllByDealerIdFileLocation(this.selectedDealer.id, fileLocation).then(response => {
        let resultTotal = response.total
        if (resultTotal > 0) {
          that.documentSentData = response.results
        }
        that.isLoading = false
      }).catch((error) => {
        that.serverErrorMessage = error.message
        that.isLoading = false
      })
    }
  },
  mounted: function () {
    this.isPdfViewerActive = true
    window.addEventListener("pdf-loaded", this.onPdfLoaded, false)
    this.$nextTick(() => {
      this.loadPdf()
    })
    this.selectedDealer = this.$store.state.dealer.currentDealer
  },
  beforeDestroy () {
    window.removeEventListener("pdf-loaded", this.onPdfLoaded);
  },
  watch: {
    selectedRecipientSupplier: function (newValue, oldValue) {
      this.selectedRecipients = []
      this.selectedRecipientsMobile = []
      if (newValue && newValue.name && newValue.email) {
        var recipient = {
          fullName: newValue.name,
          email: newValue.email
        }
        let existingContact = this.selectedRecipients.find(x => x.email === newValue.email)
        if (!existingContact) {
          this.selectedRecipients.push(recipient)
        }
        this.overridingSubject = 'Document for review'
        this.optionalMessage = this.getMessagePreface()
      } else {
        let that = this
        this.$nextTick(() => {
          that.$refs.recipientEmail.$el.focus()
        })
      }
    },
    selectedRecipientCustomer: function (newValue, oldValue) {
      this.selectedRecipients = []
      this.selectedRecipientsMobile = []
      if (newValue) {
        if (newValue.email) {
          var recipient = {
            fullName: newValue.fullName,
            email: newValue.email
          }
          let existingContact = this.selectedRecipients.find(x => x.email === newValue.email)
          if (!existingContact) {
            this.selectedRecipients.push(recipient)
          }
        } else {
          let that = this
          this.$nextTick(() => {
            that.$refs.recipientEmail.$el.focus()
          })
        }
        if (newValue.mobile) {
          let recipientMobile = {
            mobile: newValue.mobile,
            fullName: newValue.fullName
          }
          let existingContact = this.selectedRecipients.find(x => x.mobile === newValue.mobile)
          if (!existingContact) {
            this.selectedRecipientsMobile.push(recipientMobile)
          }
        }
        this.overridingSubject = 'Document for review'
        this.optionalMessage = this.getMessagePreface()
      }
    }
  }
}
</script>
<style scoped>

.pdf-modal {
  .b-tabs {
    height:100%
  }  

  .tab-content {
    display: block !important;
    height:95%;
    margin: 0;
    padding: 0;
  }  

  .tab-item  {
    height:100%
  }  

  .animation-content {
    max-width: 100% !important;
    .annotationLayer {
      position: unset !important;
    }
  }

  .modal-card {
    width: 100% !important;
    max-width: 100% !important;
  }

  .modal-card-body {
    padding: 0.5em !important;
    position:relative;
    max-height: calc(70vh - 10px) !important;
    height: calc(70vh - 10px) !important;
    max-width: 100% !important;
    min-width: 960px !important;
    overflow-y: auto !important;
  }

  .pdf-modal-body-full-screen {
    padding: 0.5em !important;
    position:relative;
    overflow-y: auto !important;
    max-height: unset !important;
    height: unset !important;
    max-width: unset !important;
    min-width: unset !important;
    width: unset !important;
  }
}

@media screen and (max-height: 600px), print {
  .pdf-modal {
    .modal-card-body {
      max-height: calc(70vh - 60px) !important;
      height: calc(70vh - 60px) !important;
    }
  }
}
.modal-card-head, .modal-card-foot {
    padding: 20px !important;
  }

  .modal-card {
    overflow: auto;
    min-width: 95% !important;
    max-width: 95% !important;
    width: 95% !important;
  }

  .modal-card-body {
    max-height: 575px !important;
    min-height: 575px !important;
    height: 575px !important;
    min-width: 855px !important;
    overflow-y: auto !important;
  }
</style>
